import { aawzDate } from '@utils/dates/aawz-date'
import { getNumber } from '@utils/Format'

export const filterActiveHistory = ({ source = [], removed = [] } = {}) => {
  const src = Array.isArray(source) ? source : []
  const removedSet = new Set(
    (Array.isArray(removed) ? removed : [])
      .filter((v) => v !== null && v !== undefined)
      .map((v) => String(v))
  )

  if (removedSet.size === 0) return src.slice()

  return src.filter((item) => {
    const id =
      (item &&
        (item.id || item.id_ativo_cliente || item.id_ativo_back_office)) ||
      null
    return !removedSet.has(String(id))
  })
}

export const buildMovementPayload = ({ item = {}, idCliente }) => {
  const dataAplic = normalizeDate(item.data_aplicacao || item.data_referencia)
  const dataCoti = normalizeDate(item.data_cotizacao || item.data_referencia)
  const hasQtd = !!item.quantidade
  const valor = hasQtd ? null : getNumber(item.valor)
  const quantidade = hasQtd ? getNumber(item.quantidade) : null
  const valorUnit = hasQtd ? getNumber(item.valor_unitario) : null
  const idAtivo = item.id || item.id_ativo_cliente || null

  return {
    id: idAtivo,
    id_ativo: idAtivo,
    id_cliente_app: idCliente,
    id_conta: item.id_conta || null,
    id_aplicacao: item.id_aplicacao || null,
    nome_ativo: item.nome_ativo || '',
    valor,
    quantidade,
    valor_unitario: valorUnit,
    data_aplicacao: dataAplic,
    data_cotizacao: dataCoti,
    resgate_total: item.resgate_total ? 1 : 0,
    alterar_saldo_em_conta: item.alterar_saldo_em_conta || null,
    corretora_saldo_em_conta: item.corretora_saldo_em_conta || null,
    pu_entrada: mapOptional(item.pu_entrada, null),
    resgate: !!item.resgate,
    marcacao_curva: !!item.marcacao_curva,
    impostos: mapOptional(item.impostos, null),
    taxas: mapOptional(item.taxas, null),
    cotacao: mapOptional(item.cotacao, null),
  }
}

export const normalizeDate = (v) => {
  if (!v) return null
  if (typeof v === 'string' && v.length === 10 && v.indexOf('/') !== -1)
    return v
  const d = aawzDate(v)
  return d.isValid() ? d.format('DD/MM/YYYY') : null
}

export const mapOptional = (value, fallback) => {
  return value === undefined ? fallback : value
}

export const summarizeQueue = (results, total) => {
  const errors = results.filter((r) => !r.ok)
  if (total === 0)
    return {
      status: 200,
      message: 'Nenhuma movimentação para enviar.',
      results,
    }
  if (errors.length === total)
    return { status: 400, message: 'Falha ao enviar movimentações.', results }
  if (errors.length > 0)
    return { status: 400, message: 'Algumas movimentações falharam.', results }
  return {
    status: 200,
    message: 'Todas as movimentações foram enviadas.',
    results,
  }
}
